export const LOCATIONS = {
    "Alabama": "US-AL",
    "Alaska": "US-AK",
    "Alberta": "CA-AB",
    "American Samoa": "US-AS",
    "Arizona": "US-AZ",
    "Arkansas": "US-AR",
    "British Columbia": "CA-BC",
    "California": "US-CA",
    "Colorado": "US-CO",
    "Connecticut": "US-CT",
    "Delaware": "US-DE",
    "District of Columbia": "US-DC",
    "Florida": "US-FL",
    "Georgia": "US-GA",
    "Guam": "US-GU",
    "Hawaii": "US-HI",
    "Idaho": "US-ID",
    "Illinois": "US-IL",
    "Indiana": "US-IN",
    "Iowa": "US-IA",
    "Kansas": "US-KS",
    "Kentucky": "US-KY",
    "Louisiana": "US-LA",
    "Maine": "US-ME",
    "Manitoba": "CA-MB",
    "Marshall Islands": "US-MH",
    "Maryland": "US-MD",
    "Massachusetts": "US-MA",
    "Michigan": "US-MI",
    "Minnesota": "US-MN",
    "Mississippi": "US-MS",
    "Missouri": "US-MO",
    "Montana": "US-MT",
    "Nebraska": "US-NE",
    "Nevada": "US-NV",
    "New Brunswick": "CA-NB",
    "New Hampshire": "US-NH",
    "New Jersey": "US-NJ",
    "New Mexico": "US-NM",
    "New York": "US-NY",
    "Newfoundland and Labrador": "CA-NL",
    "North Carolina": "US-NC",
    "North Dakota": "US-ND",
    "Northern Mariana Islands": "US-MP",
    "Northwest Territories": "CA-NT",
    "Nova Scotia": "CA-NS",
    "Nunavut": "CA-NU",
    "Ohio": "US-OH",
    "Oklahoma": "US-OK",
    "Ontario": "CA-ON",
    "Oregon": "US-OR",
    "Palau": "US-PW",
    "Pennsylvania": "US-PA",
    "Prince Edward Island": "CA-PE",
    "Puerto Rico": "US-PR",
    "Quebec": "CA-QC",
    "Rhode Island": "US-RI",
    "Saskatchewan": "CA-SK",
    "South Carolina": "US-SC",
    "South Dakota": "US-SD",
    "Tennessee": "US-TN",
    "Texas": "US-TX",
    "Utah": "US-UT",
    "Vermont": "US-VT",
    "Virgin Islands": "US-VI",
    "Virginia": "US-VA",
    "Washington": "US-WA",
    "West Virginia": "US-WV",
    "Wisconsin": "US-WI",
    "Wyoming": "US-WY",
    "Yukon": "CA-YT",
    "a1": "a1",
    "a2": "a2"
  }
    